import * as React from "react";
import { deviceType } from "../../components/Helper";
import { Key, processData } from "../Helper";
import { InfoTable } from "./InfoTable";
import { Summary } from "./Summary";
import { AdvancedView } from "../advanced/Main";

export const CommonView = (props: any): JSX.Element => {
    const meta: Key = props?.meta;
    const mcu = props?.mcu;
    const ext = props?.ext;
    const notesKey=props?.notesKey;
    const type = props?.type;
    const mcuMeta = props?.mcuMeta;
    const extMeta = props?.extMeta;
    const mcuVersion = props?.mcuVersion;
    const dType: any = deviceType
    const span = Object.keys(meta["function"][type]["EXT1"]).length;
    const typeValue = dType[type];

    const [tableData, setTableData] = React.useState<Key[]>([]);
    const [rowIds, setRowIds] = React.useState<number[]>([]);

    React.useEffect(() => {
        const props = { type, meta, mcu, ext, setRowIds, mcuMeta, extMeta, mcuVersion,notesKey }
        setTableData(processData(props))
    }, [mcu, ext,mcuVersion,type])


    return (
        <div className="row">
            <div className="col-lg-6">
                <div className="mt-1">
                    Table Representation of {(typeValue === deviceType.CNANO ? "Curiosity Nano Boards Pin Outs → CNano Touch Adapter" : "Curiosity Pro Boards Pin Outs") + "→ Touch Extension Boards."}
                </div>
                <InfoTable rowIds={rowIds} type={typeValue} span={span} mcu={mcu} ext={ext} data={tableData} />
            </div>
            <div className="col-lg-6">
                {props?.toggle ? <AdvancedView mcu={mcu} ext={ext} type={type} mcuVersion={mcuVersion} /> : <Summary type={type} mcu={mcu} ext={ext} />}
            </div>
        </div>
    )
}